import React, { useContext } from 'react';
import { mergeStyleSets } from '@fluentui/react';
import { FontIcon, FontWeights, FontSizes } from '@fluentui/react';
import TranslationsContext from 'translations/TranslationsContext';
import translationKeys from 'translationKeys';

export interface WarningMessageProps {
	children: JSX.Element | string;
	className?: string;
	isIcon?: boolean;
}

export const WarningMessage = ({ children, className = '' , isIcon = false}: WarningMessageProps) => {
	const { t } = useContext(TranslationsContext)!;
	return <p role='alert' className={`${styles.root} ${className}`}>{isIcon && <FontIcon className={styles.icon} aria-label={t(translationKeys.WarningMessage.Paragraph.AriaLabel)} iconName="Warning" />}{children}</p>;
};

const styles = mergeStyleSets({
	root: {
		display: 'flex',
		alignItems: 'center',
		flexWrap: 'nowrap',
		fontSize: FontSizes.size14,
		fontWeight: FontWeights.bold
	},
	icon: {
		height: '15px',
		fontSize: '11px',
		color: '#D83B01',
		marginRight: '6px'
	}
});
